<template>
    <form-container :header="translate('settings.users')" v-on:save="save" :disabled="loading">
        <div style="position:absolute; right:45px;">
            <div @click="toggleCrop()" class="float-right picture profile-picture-square" :title="translate('changeProfilePic')" v-if="data && data.Id && data.Id != emptyObjectId">
                <img :src="profilePictureUrl" @onerror="this.src='/img/no-profile.jpg'">
                <div class="change">
                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-camera-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                        <path fill-rule="evenodd" d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"/>
                    </svg>
                </div>
            </div>
        </div>
        <template v-slot:tabs>
            <tab :tabs="tabs" v-model="tab" ref="tabs" style="padding-right:186px;"></tab>
        </template>
        <fieldset id="tab-genel" class="tab-panel" v-show="tab == 'genel'">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>{{translate('externalSigner.name')}}</label>
                        <input @input="checkInput('FirstName',$event)" v-model="data.FirstName" type="text" class="form-control" required />
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{translate('externalSigner.surname')}}</label>
                        <input @input="checkInput('LastName',$event)" v-model="data.LastName" type="text" class="form-control" required />
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Kimlik Tipi</label>
                        <select v-model="data.Origin" required class="form-control">
                            <option value="TC">T.C. Kimliği</option>
                            <option value="Passport">Pasaport</option>
                        </select>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group" v-if="data.Origin == 'TC'">
                        <label>T.C. Kimlik No</label>
                        <input v-model="data.IdentityNumber" type="tel" class="form-control" maxlength="11" :required="isIdentityNumberRequired" />
                    </div>
                    <div class="form-group" v-else>
                        <label>Pasaport No</label>
                        <input v-model="data.IdentityNumber" type="text" class="form-control" maxlength="50" />
                        <div class="form-help">
                            E-imza sertifikasında yer alan şekliyle girin.
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="row">
                <!-- <div class="col">
                    <div class="form-group">
                        <label>Doğum Tarihi</label>
                        <date-input v-model="data.BirthDate" :isBirthDate="true" class="form-control" :required="isIdentityNumberRequired"></date-input>
                    </div>
                </div> -->
                <div class="col">
                    <div class="form-group">
                        <label>{{translate('user.cellphone')}}</label>
                        <input type="tel" maxlength="10" placeholder="5XXXXXXXXX" @input="checkInput('Mobile',$event)" v-model="data.Mobile" class="form-control" />
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{translate('customTargetSystem.email')}}</label>
                        <input v-model="data.Email" :disabled="!isNewUser()" @input="checkInput('Email',$event)" type="email" class="form-control" required />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>{{translate('user.mobileSignOperator')}}</label>
                        <select v-model="data.MobileSignOperator" class="form-control">
                            <option value="">{{translate('user.dontHaveMobileSign')}}</option>
                            <option value="TURKCELL">Turkcell</option>
                            <option value="AVEA">Türk Telekom</option>
                            <option value="VODAFONE">Vodafone</option>
                        </select>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{translate('user.mobileSignNumber')}}</label>
                        <input class="form-control" id="MobileSignNumber" :disabled="!data.MobileSignOperator" required v-model="data.MobileSignNumber" placeholder="5XXXXXXXXX" type="tel" maxlength="10">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>{{translate('approvalAuthorityEditorUser.title')}}</label> 
                         <select-input
                            :value="data.TitleId"
                            :autocomplete="true"
                            :placeholder="translate('search')"
                            :items="titles"
                            :filter-function="(item, search) => new RegExp(search, 'i').test(item.Name)"
                                        @change="titleSelectChanged"
                            style="width:100%;">
                                <span v-if="selectTitle">
                                    {{selectTitle.Name}}
                                </span>
                            <span v-else>{{translate('user.noTitle')}}</span>
                                <template v-slot:item="{item}">
                                    <div style="padding:2px 0;">
                                        {{item.Name}}
                                    </div>
                                </template>
                                    </select-input>
                    </div>
                </div>                
                <div class="col"></div>
            </div> 
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>{{translate('approvalAuthorityEditorUser.department')}}</label>
                        <select-multiple v-model="data.DepartmentIds" :autocomplete="true" :list="departments" style="height:164px;"></select-multiple>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{translate('user.pdfImage')}}</label>
                        <div class="form-control" style="height:164px;">
                            <button v-if="data.Base64SignaturePicture" @click="data.Base64SignaturePicture = null;" :title="translate('user.removePDFImage')" type="button" class="btn btn-link remove float-right" style="height:24px;"></button>
                            <img v-if="data.Base64SignaturePicture" :src="signaturePictureUrl"/>
                            <div v-else class="text-muted text-center" style="padding:50px 0">{{translate('user.signatureImageNotChosen')}}</div>
                        </div>
                        <button type="button" class="btn btn-link" @click="showSignatureCrop = true;">{{translate('user.choosePDFSignImage')}}</button>
                    </div>

                </div>
            </div>
        </fieldset>
        <fieldset id="tab-yetkiler" class="tab-panel" v-show="tab == 'yetkiler'">
            <div class="row">
                <div class="col">
                    <div class="row" v-for="a in auths" :key="a.Value">
                        <div class="col" v-if="isAuthAvailable(a.Value)">
                            <label class="mb-0">
                                <input type="checkbox" :value="a.Value" @click="setAuth(a.Value, $event.target.checked)" :checked="hasAuth(a.Value)" :disabled="(a.Group && !hasAuth(a.Group)) || data.IsExternalUser" >
                                {{a.Name}}
                            </label>
                            <small class="form-text text-muted">{{a.Description}}</small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="alert alert-info" v-if="hasAuth('Admin')">{{translate('warnings.userIsAdmin')}}</div>
                        </div>
                    </div>                      
                    <div class="row" v-if="data.IsExternalUser">
                        <div class="col">
                            <div class="alert alert-warning">{{translate('warnings.externalUserAuths')}}</div>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="IsActive" v-model="data.IsActive">
                        <label class="form-check-label" for="IsActive">
                            {{translate('user.userActive')}}
                        </label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" id="EmailNotifications" class="form-check-input" v-model="data.EmailNotifications">
                        <label class="form-check-label" for="EmailNotifications">
                            {{translate('user.sendEmailNotifs')}}
                        </label>
                        <small class="form-text text-muted">{{translate('user.sendEmailNotifsText')}}</small>
                    </div>

                    <div class="form-check">
                        <input type="checkbox" id="SmsNotifications" class="form-check-input" v-model="data.SmsNotifications">
                        <label class="form-check-label" for="SmsNotifications">
                            {{translate('user.sendSMSNotifs')}}
                        </label>
                        <small class="form-text text-muted">{{translate('user.sendSMSNotifsText')}}</small>
                    </div>

                    <div class="form-check">
                        <input type="checkbox" id="ReminderNotifications" class="form-check-input" v-model="data.ReminderNotifications">
                        <label class="form-check-label" for="ReminderNotifications">
                            {{translate('user.sendReminderNotifs')}}
                        </label>
                        <small class="form-text text-muted">{{translate('user.sendReminderNotifsText')}}</small>
                    </div>

                    <div class="row mt-4">    
                        <div class="col">  
                            <div class="form-check"  v-if="isSupportExternalUsers()">
                                <input type="checkbox" id="IsExternalUser" class="form-check-input" readonly disabled v-model="data.IsExternalUser">
                                <label class="form-check-label" for="IsExternalUser">
                                    {{translate('user.externalUser')}}
                                </label>
                            </div>                                                            
                            <label class="form--label" for="ExternalIdentitySource" style="margin:0 0 12px 17px">
                                {{translate('user.externalIdentitySource')}}: <b>{{data.ExternalIdentitySource}}</b>
                            </label>
                        </div>  
                    </div>
                </div>
            </div>
        </fieldset>
        <img-upload field="img"
            @crop-success="cropSuccess"
            lang-type="tr"
            :lang-ext="langExt"
            v-model="showCrop"
            :width="300"
            :height="300"
            :headers="{ token: axios.defaults.headers.common['token'] }"
            img-format="png"></img-upload>
        <img-upload field="imgSignature"
            @crop-success="signatureCropSuccess"
            lang-type="tr"
            :lang-ext="langExt"
            v-model="showSignatureCrop"
            :width="300"
            :height="150"
            :headers="{ token: axios.defaults.headers.common['token'] }"
            img-format="png"></img-upload>
        <template v-slot:footer>
            <div class="row">
                <div class="col">
                    <button type="button"  v-on:click="goBack" class="btn btn-outline-primary" style="margin-right: 10px;">{{translate('goBack')}}</button>
                    <tab-nav :tabs="tabs" :nextButton="false" v-model="tab"></tab-nav>
                </div>
                <div class="col text-right">
                    <tab-nav :tabs="tabs" :prevButton="false" v-model="tab" style="margin-right:12px;"></tab-nav>
                    <button type="submit" class="btn btn-success" style="margin-right:12px;">{{translate('save')}}</button>
                </div>
            </div> 
        </template>
    </form-container>
</template>

<script>
// import dateInput from '../components/DateInput.vue'
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
import selectMultiple from '../components/SelectMultiple.vue'
import imgUpload from 'vue-image-crop-upload';
import selectInput from '../components/SelectInput.vue'
import tab from '../components/Tab.vue'
import tabNav from '../components/TabNav.vue'

export default {
    mixins: [formMixin],
    components: {
        formContainer,
        // dateInput,
        selectMultiple,
        imgUpload,
        selectInput,
        tab,
        tabNav
    },
    created(){
        this.getDepartments({predicate: "IsActive= true" })
            .then(x => {
                this.departments = x.Result;
            }).catch(x => {
                console.log("Departman listesi yüklenemedi:", x);
            });

        this.getTitles({predicate: "IsActive= true" })
            .then(x => {
                this.titles = [{Id:'', Name: 'Unvan yok'}].concat(x.Result);
            }).catch(x => {
                console.log("Unvan listesi yüklenemedi:", x);
            });

        this.getAuthorizationDefinitions()
            .then(x => {
                this.auths = x;
            }).catch(x => {
                console.log('Kullanıcı yetki tanımları yüklenemedi.', x);
            })

        this.getData(this.$route.params.id);
    },
    data() {
        return {
            emptyObjectId: window.emptyObjectId,
            loading: false,
            modelName: 'User',
            data: {},
            departments: [],
            titles: [],
            tab: 'genel',
            tabs: [
                { key:'genel', text: this.translate('tabs.userTabs.general') },
                { key:'yetkiler', text: this.translate('tabs.userTabs.auths') }
                ],
            auths: [],
            imgDataUrl: '', // Profil resmi için  datebase64 url of created image
            showCrop: false,    // Profil resmi kesme paneli gösterilsin mi
            showSignatureCrop: false,   // İmza resmi kesme paneli gösterilsin mi
            langExt: {
                hint: this.translate('user.helperText'),
                loading: this.translate('loading'),
                noSupported: this.translate('user.browserNotSupported'),
                success: this.translate('messages.uploadSuccess'),
                fail: this.translate('errors.uploadFailed'),
                preview: this.translate('preview'),
                btn: {
                    off: this.translate('cancel'),
                    close: this.translate('close'),
                    back: this.translate('anotherFile'),
                    save: this.translate('okay')
                },
                error: {
                    onlyImg: this.translate('onlyPic'),
                    outOfSize: this.translate('fileSizeExceeded'),
                    lowestPx: this.translate('picSizeSmall')
                }
            }
        }
    },
    computed: {
        selectTitle(){
            return this.titles.filter(x => x.Id == this.data.TitleId)[0];
        },
        profilePictureUrl(){
            return this.data.Base64ProfilePicture == null ? require("../assets/no-profile.jpg") : "data:image/png;base64," + this.data.Base64ProfilePicture;
        },
        signaturePictureUrl(){
            return "data:image/png;base64," + this.data.Base64SignaturePicture;
        }        
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
        isNewUser(){
           if(this.$route.params.id == "000000000000000000000000")
               return true;
            return false;
        } ,
        titleSelectChanged(value){
            this.data.TitleId = value?.Id;
        },
        toggleCrop() {
            this.showCrop = !this.showCrop;
        },
        cropSuccess(imgDataUrl){
            this.data.Base64ProfilePicture = imgDataUrl.substring(imgDataUrl.indexOf(',')+1, imgDataUrl.length);
        },
        signatureCropSuccess(imgDataUrl){
            this.data.Base64SignaturePicture = imgDataUrl.substring(imgDataUrl.indexOf(',')+1, imgDataUrl.length);
        },
        hasAuth(auth) {
            return this.data?.Authorities?.indexOf(auth) >= 0 || false;
        },
        setAuth(auth, state) {
            this.data.Authorities = this.data.Authorities.filter(x => x != auth);

            if(state)
                this.data.Authorities.push(auth);
        },
        isAuthAvailable(auth) {
            if(auth == 'Admin')
                return false;

            if(auth == 'Approver' || auth == 'Signer')
                return true;

            return !this.hasAuth('Admin');
        },
        goTab(newTab){
            if(this.tab == 'genel') {
                var input = document.getElementById('MobileSignNumber');
                if(!input.reportValidity())
                    return;
            }

            this.tab = newTab;
        },
        goNextTab(){ 
            var curIndex = this.tabs.findIndex(x => x.key == this.tab);
            var newTab = this.tabs[curIndex + 1];
            if(newTab)
                this.goTab(newTab.key);
        },
        goPrevTab() {
            var curIndex = this.tabs.findIndex(x => x.key == this.tab) - 1;
            if(curIndex < 0)
                curIndex = 0;

            this.goTab(this.tabs[curIndex].key);
        }
    }
}
</script>
<style scoped>
.picture {
    cursor: pointer;
    margin-top: -110px;
    overflow: hidden;
    width: 128px;
    height: 128px;
}

.picture img {
    width:120px;
    height:120px;
}

.picture .change {
    text-align: center;
    width:120px;
    height:50px;
    background: rgba(0, 0, 0, 0.3);
    position: relative;
    margin-top: -50px;
    padding-top:8px;
    color:#EEE;
    opacity: 0;
    transition: opacity .5s;
}

.picture:hover .change {
    opacity: 1;
}

.tab-panel {
  min-height: 600px;
}

.text-muted{
    margin:0 0 12px 17px
}
</style>